export class PipeRiserUtility {
  static ftDivider = 12

  constructor(inches) {
    this.inches = inches
  }

  get ft() {
    return this.inches / PipeRiserUtility.ftDivider
  }
}

export default class PipeRiser {
  static TYPE = {
    _M: {
      identifier:null,
      tConnections: 3,
      imgType: 'PIPE_RISER',
      od: new PipeRiserUtility(30),
      width: new PipeRiserUtility(30),
      length: new PipeRiserUtility(30),
      description: '36" X 90" MANIFOLD BEND',
    },
    _3698AN: {
      tConnections: 3,
      imgType: 'PIPE_RISER',
      od: new PipeRiserUtility(30),
      width: new PipeRiserUtility(52.3),
      length: new PipeRiserUtility(52.3),
      description: '36" X 90" MANIFOLD BEND',
    },
  }
}



// WEBPACK FOOTER //
// ./src/lib/Pipes/PipeAccessories/pipe-riser.js